import { render } from "./NutritionDashboard.vue?vue&type=template&id=21805830&scoped=true"
import script from "./NutritionDashboard.vue?vue&type=script&lang=js"
export * from "./NutritionDashboard.vue?vue&type=script&lang=js"

import "./NutritionDashboard.vue?vue&type=style&index=0&id=21805830&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21805830"]])

export default __exports__